import { useEffect, useState } from "react"
import dict from "../../Data/dict.json"
import { useSelector } from "react-redux"

import pic_static from "../../Assets/svg/profile_pic_comment.svg"
import icon_close from "../../Assets/svg/icon_close.svg"
import axios from "axios"

const config = {
    headers: {
        accesstoken: localStorage.token_mapid,
    },
};


export default function DeleteAccount(){
    const language = localStorage?.language || "ina"
    let auth = useSelector((state) => state.auth)
    const [collaborators, setCollaborators] = useState([])
    const [selectedData, setSelectedData] = useState({})
    const [showModal, setShowModal] = useState(false)
    const [showModalNotification, setShowModalNotification] = useState(false)
    const [notification, setNotification] = useState({
        type: "",
        message: ""
    })

    const handleClick = (data) => {
        setSelectedData(data)
        setShowModal(true)
    }

    const handleSubmit = (e) => {
        const value = e.target["insert-name"].value
        if(!value) return;
        setSelectedData({name: value})
        setShowModal(true)
    }

    useEffect(() => {
        setCollaborators(auth.collaborators)
    },[auth])
    
    return (
        <>
            {showModal ? 
                <main
                    className="main_container"
                    style={{position: "absolute", bottom: 0, top: 0, right: 0, left: 0}}
                >
                    {showModalNotification ? <ModalNotification type={notification.type} message={notification.message}/> : <></>}
                    <ModalDeleteConfirm data={selectedData} showModal={showModal} setShowModal={setShowModal} showModalNotification={showModalNotification} setShowModalNotification={setShowModalNotification} setNotification={setNotification}/>
                </main>
                : 
                <main 
                    className="main_container"
                >
                        <>
                            <section className="header_medium" style={{ marginBottom: "20px" }}>
                                {dict["Delete Account"][language]}
                            </section>
                            <br />
                            <div className="box-body">
                                <form onSubmit={(e) => {
                                    e.preventDefault()
                                    handleSubmit(e)
                                    }} 
                                    className="input_rounded margin-top" 
                                    style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "2rem"}}
                                >
                                    <input 
                                        className="form-rounded"
                                        type="text"
                                        name="insert-name"
                                    />
                                    <button
                                        className="button_very_small background_red"
                                        style={{height: "fit-content"}}
                                        type="submit"
                                    >
                                        Delete
                                    </button>
                                </form>
                            </div>
                            <br />
                            {collaborators.map((collaborator, index) => {
                                const _id = collaborator?._id
                                const name = collaborator?.name
                                const full_name = collaborator?.full_name || name || `member ${index}`
                                const profile_picture = collaborator?.profile_picture
                
                                const displayName = full_name && full_name !== "" && full_name !== "-" ? full_name : name
                                const profilePic = profile_picture && profile_picture.url_compressed 
                                        ? profile_picture.url_compressed 
                                        : profile_picture && profile_picture.url && ![
                                        "https://s3-us-west-2.amazonaws.com/geomapid-assets/astronot.png",
                                        "-",
                                        "default",
                                        ].includes(profile_picture.url) 
                                        ? profile_picture.url
                                        : pic_static
                
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            backgroundColor: "#fff",
                                            padding: "10px",
                                            marginBottom: "10px",
                                            borderRadius: "6px"
                                        }}
                                    >
                                        <div style={{display: "flex", alignItems: "center"}}>
                                            <span 
                                                style={{marginRight: "1rem", marginLeft: "1rem"}}
                                            >
                                                {index + 1}.
                                            </span>
                                            <section
                                                alt={_id}
                                                className="user-photo"
                                                style={{
                                                    backgroundImage: `url(${profilePic})`,
                                                    marginRight: "10px"
                                                }}
                                            >
                                            </section>
                                            <span>{displayName}</span>
                                        </div>
                                        <button
                                            className="button_very_small background_red"
                                            onClick={()=>handleClick(collaborator)}
                                        >
                                            {dict["Delete"][language]}
                                        </button>
                                    </div>
                                )
                            })}
                        </>
                </main>
            }
        </>
    )
}

const ModalDeleteConfirm = (props) => {
    const {data, setShowModal, setShowModalNotification, setNotification} = props

    const handleClick = () => {
        setShowModal(false)
    }

    const handleSubmit = async (e) => {
        try {
            const reason = e.target["reason"].value
            if(!reason) return
    
            const newData = {
                username: data.name,
                reason: reason
            }
            const result = await axios.post("https://n8n.mapid.co.id/webhook/dsda-delete-account-request", newData, config)
            if(result.status === 200){
                setShowModalNotification(true)
                setNotification({type: "success", message: "Delete request sent successfully!"})
            }
        } catch (error) {
            setShowModalNotification(true)
            setNotification({type: "error", message: error.message})
        } finally {
            setTimeout(() => {
                setShowModalNotification(false)
                setNotification({type: "", message: ""})
                setShowModal(false)
            },1000)
        }
    }

    return (
        <div style={{position: "relative"}}>
            <form
                className="input_rounded margin-top"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    paddingTop: "1rem",
                    paddingBottom: "1rem"
                }}
                onSubmit={(e) => {
                    e.preventDefault()
                    handleSubmit(e)
                }}
            >
                <div>
                    <p style={{fontWeight: "bold"}}>Name</p>
                    <p>{data?.name}</p>
                </div>
                <label htmlFor="reason">
                    <div style={{display: "flex", flexDirection: "column", gap: ".5rem"}}>
                        <p style={{fontWeight: "bold"}}>Reason</p>
                        <textarea name="reason" id="reason" className="form-rounded"></textarea>
                    </div>
                </label>
                <button type="submit" className="button_big background_black" style={{width: "fit-content", alignSelf: "center"}}>Submit</button>
            </form>
            <button
                style={{position: "absolute", top: 0, right: 0}}
                onClick={handleClick}
            >
                <img src={icon_close} alt="" />
            </button>
        </div>
    )
}

const ModalNotification = (props) => {
    const {type = "success", message = ""} = props
    return (
        <div style={{position: "fixed", bottom: "1rem", right: "1rem", backgroundColor: `${type === "error" ? "red" : "#83cc16"}`, borderRadius: ".5rem", padding: "1rem", color: "white", width: "fit-content"}}>
            {message}
        </div>
    )
}